import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { getBotConfig, getUserId } from '../../redux'
import operations from '../../redux/operations'

function ButtonAction({
  button,
  circular,
  sendQuickReply,
  botConfig,
  userId,
}) {
  if (button.type === 'openUrl') {
    return (
      <Button
        basic
        as="a"
        color="blabla"
        target="_blank"
        href={button.value}
        content={button.title}
      />
    )
  } else if (button.type === 'blank' || button.type === 'self' || button.type === 'top') {
    return (
      <div className="buttons">
        <button className="ui blabla basic button weburl">
          <a 
          href={button.value}
          target={`_${button.type}`}
          rel="noopener noreferrer"
          >
            {button.title || "Sélectioner"}
          </a>
        </button>
      </div>
    )
  } else if (button.type === 'web_url') {
    return (
      <div className="buttons">
        <button className="ui blabla basic button weburl">
          <a 
          href={button.url}
          target="_top"
          rel="noopener noreferrer"
          >
            {button.title || "Sélectioner"}
          </a>
        </button>
      </div>
    )
  } else if (button.type === 'postBack') {
    const value = button.value
    return (
      <div className="buttons">
        <button 
          className="ui blabla basic button"
          onClick={(e, data) => {
            sendQuickReply(botConfig, value, { content: button.title }, userId)
          }}>
          <span>{button.title}</span>
        </button>
        <div 
          className="carrousel-button"
        >
          <span>
            Sélectionner
          </span>
        </div>
      </div>
    )
  } else {
    return (null)
  }
}

ButtonAction.propTypes = {
  button: PropTypes.object.isRequired,
  circular: PropTypes.bool,
  sendQuickReply: PropTypes.func.isRequired,
  botConfig: PropTypes.object.isRequired,
  userId: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  botConfig: getBotConfig(state),
  userId: getUserId(state),
});

export default connect(
  mapStateToProps,
  operations,
)(ButtonAction)

// export default ButtonAction



// WEBPACK FOOTER //
// ./src/views/components/Button.js